import styled from "styled-components";
import { tokens } from "../../public/tokens";

const { colors, typography, globals } = tokens;
const { brand, neutral, text } = colors;

/**
 * The tint pairs a qualification pill can be drawn in, keyed by the brand
 * palette name held in `sp_programme_type.hue`. The database chooses which
 * palette a qualification type uses; the values stay here so tokens.js remains
 * the single source of color.
 */
export const qualificationTagHues = {
    "burnt-orange": {
        color: brand["burnt-orange"]["600"],
        backgroundColor: brand["burnt-orange"]["200"],
    },
    naartjie: {
        color: brand.naartjie["500"],
        backgroundColor: brand.naartjie["200"],
    },
    "fresh-green": {
        color: brand["fresh-green"]["600"],
        backgroundColor: brand["fresh-green"]["200"],
    },
    "tide-blue": {
        color: brand["tide-blue"]["500"],
        backgroundColor: brand["tide-blue"]["200"],
    },
    "plum-orchid": {
        color: brand["plum-orchid"]["500"],
        backgroundColor: brand["plum-orchid"]["200"],
    },
    blue: {
        color: brand.blue["500"],
        backgroundColor: brand.blue["200"],
    },
    grey: {
        color: neutral.grey["600"],
        backgroundColor: neutral.grey["300"],
    },
};

export const QualificationTag = styled.span(({ $hue }) => ({
    display: "inline-flex",
    width: "fit-content",
    alignItems: "center",
    gap: globals["spacing-1-5"],
    margin: 0,
    padding: `${globals["spacing-1"]} ${globals["spacing-1-5"]}`,
    fontFamily: globals["font-family"],
    fontSize: typography.fontSize["sm-10px"],
    fontWeight: typography.fontWeights.bold,
    lineHeight: typography.lineHeights["100"],
    textTransform: "none",
    whiteSpace: "nowrap",
    borderRadius: globals["border-radius"],
    color: text.primary,
    ...qualificationTagHues[$hue],
}));
